import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";

function RejectDialog({
  open,
  onClose,
  onConfirm,
  processing,
  error,
  success,
}) {
  // Local state to control dialog message and status
  const [dialogStatus, setDialogStatus] = useState("idle"); // "idle", "processing", "success", "error"
  const [dialogMessage, setDialogMessage] = useState("");

  useEffect(() => {
    if (dialogStatus === "idle") {
      setDialogMessage("Are you sure you want to reject this submission?");
    } else if (dialogStatus === "processing") {
      setDialogMessage("Processing rejection...");
    } else if (dialogStatus === "success") {
      setDialogMessage("Submission rejected successfully.");
    } else if (dialogStatus === "error") {
      setDialogMessage("Failed to reject submission. Please try again.");
    }
  }, [dialogStatus]);

  useEffect(() => {
    if (processing) {
      setDialogStatus("processing");
    } else if (success) {
      setDialogStatus("success");
    } else if (error) {
      setDialogStatus("error");
    }
  }, [processing, success, error]);

  const handleConfirmClick = () => {
    if (onConfirm) {
      onConfirm();
    }
    setDialogStatus("processing");
  };

  const handleCloseClick = () => {
    setDialogStatus("idle");
    if (onClose) {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={dialogStatus === "processing" ? null : handleCloseClick}
      disableEscapeKeyDown={dialogStatus === "processing"}
    >
      <DialogTitle>Rejection Status</DialogTitle>
      <DialogContent
        sx={{ display: "flex", alignItems: "center", gap: 2, minWidth: 300 }}
      >
        {dialogStatus === "processing" && <CircularProgress />}
        <Typography>{dialogMessage}</Typography>
      </DialogContent>
      <DialogActions>
        {dialogStatus !== "processing" && (
          <Button onClick={handleCloseClick} autoFocus>
            {dialogStatus === "idle" ? "Cancel" : "Close"}
          </Button>
        )}
        {dialogStatus === "idle" && (
          <Button onClick={handleConfirmClick} autoFocus>
            Confirm
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default RejectDialog;
